import * as React from 'react'
import { DefaultContent } from 'react-content-engine'
import { getLinkName, Slink } from '../../routing/links'

interface MenuLinkProps {
  match: any
}

const MenuLink: React.FC<MenuLinkProps> = props => {
  const { match } = props
  const name = getLinkName(match.url)

  return (
    <ul>
      <li className={name === 'trips' ? 'is-current' : ''}>
        <Slink name="trips">
          <DefaultContent contentKey="srprs-trips">Srprs.trips</DefaultContent>
        </Slink>
      </li>
      <li className={name === 'how' ? 'is-current' : ''}>
        <Slink name="how">
          <DefaultContent contentKey="how-works">How it works</DefaultContent>
        </Slink>
      </li>
      <li className={name === 'about' ? 'is-current' : ''}>
        <Slink name="about">
          <DefaultContent contentKey="about-us">About us</DefaultContent>
        </Slink>
      </li>
      <li className={name === 'service' ? 'is-current' : ''}>
        <Slink name="service">
          <DefaultContent contentKey="contact-support">
            Contact & Support
          </DefaultContent>
        </Slink>
      </li>
      <li className={name === 'gift' ? 'is-current' : ''}>
        <Slink name="gift">
          <DefaultContent contentKey="as-a-gift">Giftcard</DefaultContent>
        </Slink>
      </li>
    </ul>
  )
}

export default MenuLink
